import { __decorate } from "tslib";
import { injectable } from 'inversify';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
let SpaceRecentListApiImpl = class SpaceRecentListApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getRecentList() {
        const res = await this.get({
            url: '/all-recent-spaces',
        });
        return res.data;
    }
};
SpaceRecentListApiImpl = __decorate([
    injectable()
], SpaceRecentListApiImpl);
export { SpaceRecentListApiImpl };
